export default "Syndics et conseils syndicaux : audit CEE, cumul MaPrimeRénov’ Copro + primes CEE collectives + éco-PTZ. Présentation en AG offerte, projet de résolution rédigé.";
